module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-overlay"
  }, [_c('div', {
    staticClass: "modal-wrapper showSweetAlert visible bulk-wrapper",
    attrs: {
      "data-animation": "pop"
    }
  }, [(_vm.displayQuestion) ? _c('question') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-close col-sm-12 text-right"
  }, [_c('button', {
    staticClass: "modal-button",
    on: {
      "click": _vm.close
    }
  }, [_c('span', {
    staticClass: "icon-close"
  })])]), _vm._v(" "), _c('header', {
    staticClass: "modal-header"
  }, [_c('h2', {
    staticClass: "modal-title"
  }, [_vm._v("Redeem/approve all open notes")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body mt-lg"
  }, [(_vm.loading) ? _c('spinner', {
    attrs: {
      "text": _vm.loadingText,
      "inline": ""
    }
  }) : (_vm.result) ? _c('div', [_c('div', {
    staticClass: "alert",
    class: _vm.result.failed ? 'alert-warning' : 'alert-success',
    attrs: {
      "role": "alert"
    }
  }, [(!_vm.result.failed) ? _c('h4', [_vm._v(_vm._s(_vm.result.title))]) : _c('h4', [_vm._v(_vm._s(_vm.result.title) + " — with failures")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.result.message))])]), _vm._v(" "), (_vm.result.failed) ? _c('div', {
    staticClass: "failures-block"
  }, [_c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\n            These notes were not processed and must be handled individually:\n          ")]), _vm._v(" "), _c('ul', {
    staticClass: "failure-list"
  }, _vm._l((_vm.result.failures), function(failure) {
    return _c('li', {
      key: failure.noteId
    }, [_vm._v("\n              Note #" + _vm._s(failure.noteId) + " — " + _vm._s(failure.errorMessage) + "\n            ")])
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-buttons mt-lg"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg btn-accept",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n                Done\n              ")])])])])]) : (_vm.isApproval) ? _c('div', [_c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "role": "alert"
    }
  }, [_c('p', [_vm._v("\n            A bulk redemption request for\n            "), _c('strong', [_vm._v(_vm._s(_vm.openBatch.noteCount))]), _vm._v(" notes is awaiting\n            approval on this account. Check the details below before\n            approving.\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('fieldset', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Bank account")]), _vm._v(" "), _c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.requestFundingSourceLabel))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('fieldset', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Service fee (whole batch)")]), _vm._v(" "), _c('p', {
    staticClass: "form-control-static"
  }, [_vm._v("\n                " + _vm._s(_vm.formatAmount(_vm.openBatch.serviceFee || 0)) + "\n                "), (_vm.requestFeeBearer) ? _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("\n                  — charged once, to note " + _vm._s(_vm.requestFeeBearer.noteNumber) + "\n                ")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('fieldset', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Redemption category")]), _vm._v(" "), _c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.requestCategoryLabel))])])])]), _vm._v(" "), _c('div', {
    staticClass: "totals-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "totals-label"
  }, [_vm._v("Notes to redeem")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_c('strong', [_vm._v(_vm._s(_vm.openBatch.noteCount))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "totals-label"
  }, [_vm._v("Principal")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_vm._v("\n              " + _vm._s(_vm.formatAmount(_vm.requestTotals.principal)) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "totals-label"
  }, [_vm._v("Interest")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_vm._v("\n              " + _vm._s(_vm.formatAmount(_vm.requestTotals.interest)) + "\n            ")])]), _vm._v(" "), (_vm.requestTotals.fee > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "totals-label"
  }, [_vm._v("Service fee")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right text-danger"
  }, [_vm._v("\n              −" + _vm._s(_vm.formatAmount(_vm.requestTotals.fee)) + "\n            ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row total-row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "totals-label"
  }, [_vm._v("Total paid to investor")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right total-amount"
  }, [_vm._v("\n              " + _vm._s(_vm.formatAmount(_vm.requestNetPayout)) + "\n            ")])])]), _vm._v(" "), (_vm.requestNotes.length) ? _c('p', {
    staticClass: "toggle-link"
  }, [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showNotes = !_vm.showNotes
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.showNotes ? 'Hide' : 'Show') + " the " + _vm._s(_vm.requestNotes.length) + " notes\n            being redeemed\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.showNotes && _vm.requestNotes.length) ? _c('div', {
    staticClass: "note-list"
  }, [_c('table', {
    staticClass: "table table-condensed"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Note")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Principal")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Interest")]), _vm._v(" "), (_vm.requestTotals.fee > 0) ? _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Fee")]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.requestNotes), function(note) {
    return _c('tr', {
      key: note.noteId
    }, [_c('td', [_vm._v(_vm._s(note.noteNumber))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatAmount(note.principalAmount)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatAmount(note.interestAmount)))]), _vm._v(" "), (_vm.requestTotals.fee > 0) ? _c('td', {
      staticClass: "text-right"
    }, [(note.feeAmount > 0) ? _c('span', {
      staticClass: "text-danger"
    }, [_vm._v("\n                    −" + _vm._s(_vm.formatAmount(note.feeAmount)) + "\n                  ")]) : _c('span', {
      staticClass: "text-muted"
    }, [_vm._v("—")])]) : _vm._e()])
  }))])]) : _vm._e(), _vm._v(" "), _c('fieldset', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "bulkApprovalComment"
    }
  }, [_vm._v("Please append your comment below *")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.approvalComment),
      expression: "approvalComment",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "bulkApprovalComment",
      "rows": "4",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.approvalComment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.approvalComment = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (!_vm.hasAppendedComment) ? _c('p', {
    staticClass: "text-danger"
  }, [_c('em', [_vm._v("You must enter or append a comment.")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-buttons mt-lg"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg btn-cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n                Close\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg btn-discard",
    attrs: {
      "type": "button",
      "disabled": !_vm.hasAppendedComment
    },
    on: {
      "click": _vm.confirmCancelBatch
    }
  }, [_vm._v("\n                Cancel request\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg btn-accept",
    attrs: {
      "type": "button",
      "disabled": !_vm.hasAppendedComment
    },
    on: {
      "click": _vm.confirmApproval
    }
  }, [_vm._v("\n                Approve all\n              ")])])])])]) : _c('div', [(_vm.preview.eligibleCount === 0) ? _c('div', {
    staticClass: "alert alert-warning",
    attrs: {
      "role": "alert"
    }
  }, [_c('p', [_vm._v("\n            No notes on this account can be bulk redeemed\n            "), (_vm.preview.ineligibleCount) ? _c('span', [_vm._v("\n              — all " + _vm._s(_vm.preview.ineligibleCount) + " open notes are excluded.\n              See the reasons below.\n            ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('fieldset', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "bulkFundingSource"
    }
  }, [_vm._v("Bank account *")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fundingSourceId),
      expression: "fundingSourceId"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "bulkFundingSource"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.fundingSourceId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Please select")]), _vm._v(" "), _vm._l((_vm.fundingSources), function(fs) {
    return _c('option', {
      key: fs.id,
      domProps: {
        "value": String(fs.id)
      }
    }, [_vm._v("\n                  " + _vm._s(fs.name) + "\n                ")])
  }), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.donateFundingSource.name
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.donateFundingSource.text) + "\n                ")])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('fieldset', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "bulkServiceFee"
    }
  }, [_vm._v("Service fee (whole batch)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.serviceFeeInput),
      expression: "serviceFeeInput"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "id": "bulkServiceFee",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.serviceFeeInput)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.serviceFeeInput = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fee-hint",
    class: _vm.preview.feeError ? 'text-danger' : 'text-muted'
  }, [(_vm.refreshing) ? _c('span', [_vm._v("Recalculating…")]) : (_vm.preview.feeError) ? _c('span', [_vm._v(_vm._s(_vm.preview.feeError))]) : (_vm.preview.feeBearer) ? _c('span', [_vm._v("\n                  Charged once, to note " + _vm._s(_vm.preview.feeBearer.noteNumber) + "\n                  (" + _vm._s(_vm.formatAmount(_vm.preview.feeBearer.currentBalance)) + ") — the\n                  largest note in the batch.\n                ")]) : _c('span', [_vm._v("\n                  Charged once for the whole batch, not per note.\n                ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('fieldset', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "bulkCategory"
    }
  }, [_vm._v("Redemption category *")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.categoryId),
      expression: "categoryId"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "bulkCategory"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.categoryId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.preview.redemptionCategories), function(rc) {
    return _c('option', {
      key: rc.id,
      domProps: {
        "value": rc.id
      }
    }, [_vm._v("\n                  " + _vm._s(rc.label) + "\n                ")])
  }))])]), _vm._v(" "), (_vm.needsCategoryHelperText) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('fieldset', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "bulkCategoryHelperText"
    }
  }, [_vm._v("Category detail *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.categoryHelperText),
      expression: "categoryHelperText",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "bulkCategoryHelperText",
      "placeholder": "Enter a redemption category…",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.categoryHelperText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.categoryHelperText = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "totals-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "totals-label"
  }, [_vm._v("Notes to redeem")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_c('strong', [_vm._v(_vm._s(_vm.preview.eligibleCount))]), _vm._v(" "), (_vm.preview.ineligibleCount) ? _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("\n                (" + _vm._s(_vm.preview.ineligibleCount) + " excluded)\n              ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "totals-label"
  }, [_vm._v("Principal")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_vm._v(_vm._s(_vm.formatAmount(_vm.preview.totals.principal)))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "totals-label"
  }, [_vm._v("Interest")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_vm._v(_vm._s(_vm.formatAmount(_vm.preview.totals.interest)))])]), _vm._v(" "), (_vm.preview.totals.fee > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "totals-label"
  }, [_vm._v("\n                Service fee\n                "), (_vm.preview.feeBearer) ? _c('span', [_vm._v("\n                  (on note " + _vm._s(_vm.preview.feeBearer.noteNumber) + ")\n                ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right text-danger"
  }, [_vm._v("\n              −" + _vm._s(_vm.formatAmount(_vm.preview.totals.fee)) + "\n            ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row total-row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "totals-label"
  }, [_vm._v("Total paid to investor")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right total-amount"
  }, [_vm._v("\n              " + _vm._s(_vm.formatAmount(_vm.preview.totals.netPayout)) + "\n            ")])])]), _vm._v(" "), _c('fieldset', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "bulkComment"
    }
  }, [_vm._v("Please append your comment *")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.comment),
      expression: "comment",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "bulkComment",
      "rows": "2",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comment = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toggle-link"
  }, [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showNotes = !_vm.showNotes
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.showNotes ? 'Hide' : 'Show') + " the " + _vm._s(_vm.preview.eligibleCount) + " notes\n            being redeemed\n          ")])]), _vm._v(" "), (_vm.showNotes) ? _c('div', {
    staticClass: "note-list"
  }, [_c('table', {
    staticClass: "table table-condensed"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Note")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Principal")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Interest")]), _vm._v(" "), (_vm.preview.totals.fee > 0) ? _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Fee")]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.preview.eligibleNotes), function(note) {
    return _c('tr', {
      key: note.noteId
    }, [_c('td', [_vm._v(_vm._s(note.noteNumber))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatAmount(note.currentBalance)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatAmount(note.accruedInterest)))]), _vm._v(" "), (_vm.preview.totals.fee > 0) ? _c('td', {
      staticClass: "text-right"
    }, [(note.serviceFee > 0) ? _c('span', {
      staticClass: "text-danger"
    }, [_vm._v("\n                    −" + _vm._s(_vm.formatAmount(note.serviceFee)) + "\n                  ")]) : _c('span', {
      staticClass: "text-muted"
    }, [_vm._v("—")])]) : _vm._e()])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.preview.ineligibleCount) ? _c('p', {
    staticClass: "toggle-link"
  }, [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showExcluded = !_vm.showExcluded
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.showExcluded ? 'Hide' : 'Show') + " the " + _vm._s(_vm.preview.ineligibleCount) + " excluded\n            notes\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.showExcluded) ? _c('div', {
    staticClass: "note-list"
  }, [_c('table', {
    staticClass: "table table-condensed"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Note")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Principal")]), _vm._v(" "), _c('th', [_vm._v("Why it is excluded")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.preview.ineligibleNotes), function(note) {
    return _c('tr', {
      key: note.noteId
    }, [_c('td', [_vm._v(_vm._s(note.noteNumber))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatAmount(note.currentBalance)))]), _vm._v(" "), _c('td', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(note.ineligibilityText))])])
  }))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-buttons mt-lg"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg btn-cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n                Cancel\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg btn-accept",
    attrs: {
      "type": "button",
      "disabled": !_vm.canSubmit
    },
    on: {
      "click": _vm.confirmSubmit
    }
  }, [_vm._v("\n                Redeem " + _vm._s(_vm.preview.eligibleCount) + " notes\n              ")])])])])])], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1aca2a74","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/BulkRedemption.vue
// module id = 2111
// module chunks = 1